require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es6.array.species.js
// module id = 258
// module chunks = 0